import { render, staticRenderFns } from "./NewPostCard.vue?vue&type=template&id=11bfc5bb&"
import script from "./NewPostCard.vue?vue&type=script&lang=js&"
export * from "./NewPostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports